import { useQuery } from '@tanstack/react-query'
import { getBillingDetails } from '../services'
import { CryptoInvoiceQueryKeys } from '../../keys'

import type { GetBillingDetailsRequest } from '../../type'

export default function useQueryGetBillingDetails(
	payload: GetBillingDetailsRequest,
) {
	return useQuery({
		queryKey: [CryptoInvoiceQueryKeys.BillingDetails, payload],
		queryFn: () => getBillingDetails(payload),
		enabled: !!payload.billingMonth,
	})
}
